import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ModuleWithProviders, NgModule, PLATFORM_ID, Provider } from '@angular/core';
import { BroadcastChannel } from 'broadcast-channel';
import { BroadcastChannelService } from './broadcast-channel.service';
import { BROADCAST_CHANNELS } from './broadcast-channel.token';
import { BroadcastChannelDefault } from './model/broadcast-channel.interface';

@NgModule({
  imports: [CommonModule],
})
export class BroadcastChannelModule {
  static forRoot(options?: { channelNames: string[] }): ModuleWithProviders<BroadcastChannelModule> {
    const providers: Provider[] = [
      {
        provide: BROADCAST_CHANNELS,
        useFactory: (platformId: object) => {
          const records = new Map<string, BroadcastChannel>();

          // Only create BroadcastChannel instances in browser environment
          if (isPlatformBrowser(platformId)) {
            options?.channelNames.forEach(name => {
              if (!records.has(name)) {
                records.set(name, new BroadcastChannel(name));
              }
            });
            if (!records.has(BroadcastChannelDefault.APP)) {
              records.set(BroadcastChannelDefault.APP, new BroadcastChannel(BroadcastChannelDefault.APP));
            }
          }

          return records;
        },
        deps: [PLATFORM_ID],
      },
      BroadcastChannelService,
    ];
    return {
      ngModule: BroadcastChannelModule,
      providers: [...providers],
    };
  }
}
